import React from 'react'
import syrvey from '../assets/langprofile-2017.jpg'

const TISLanguageProfile = () => {
    return (

        <section className='p-4 md:p-24'>

            <div className='flex flex-col gap-5'>

                <h1 className='text-xl md:text-4xl font-light'>TIS Language Profile</h1>

                <p className='font-semibold'>At the International School, support for Mother Tongue languages is provided on the basis of the following data, collected through the Language Profile Survey:</p>

                <h6 className='text-xl font-semibold md:text-3xl text-center'>
                    Survey
                </h6>

                <figure className='mx-auto md:w-[36%] '>
                    <img src={syrvey} alt='Language profile survey results' className='w-full h-full object-contain' />
                </figure>


            </div>

        </section>
    )
}

export default TISLanguageProfile